import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { formatApiErrorDetail } from "../lib/api";
import AuthShell from "../components/AuthShell";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      await login(email, password);
      toast.success("Bem-vindo de volta!");
      navigate("/dashboard");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell
      title="Entrar na plataforma"
      subtitle="Aqueça seus chips WhatsApp sem risco de banimento, direto na nuvem."
      footer={
        <span>
          Não tem conta?{" "}
          <Link to="/cadastro" className="text-emerald-400 hover:text-emerald-300 font-medium" data-testid="link-cadastro">
            Criar conta grátis
          </Link>
        </span>
      }
    >
      <form onSubmit={handleSubmit} className="space-y-4">
        {error && (
          <div className="bg-red-500/10 border border-red-500/30 rounded-lg p-3 text-sm text-red-300" data-testid="auth-login-error">
            {error}
          </div>
        )}
        <div className="space-y-1.5">
          <Label htmlFor="email" className="text-slate-300">E-mail</Label>
          <Input
            id="email"
            type="email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="voce@empresa.com.br"
            data-testid="auth-login-email-input"
            className="bg-slate-800/60 border-slate-700 text-slate-100 placeholder:text-slate-500 focus-visible:ring-2 focus-visible:ring-emerald-500"
          />
        </div>
        <div className="space-y-1.5">
          <div className="flex items-center justify-between">
            <Label htmlFor="password" className="text-slate-300">Senha</Label>
            <Link to="/esqueci-senha" className="text-xs text-emerald-400 hover:text-emerald-300" data-testid="link-esqueci-senha">
              Esqueci a senha
            </Link>
          </div>
          <Input
            id="password"
            type="password"
            required
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="••••••••"
            data-testid="auth-login-password-input"
            className="bg-slate-800/60 border-slate-700 text-slate-100 placeholder:text-slate-500 focus-visible:ring-2 focus-visible:ring-emerald-500"
          />
        </div>
        <Button
          type="submit"
          disabled={loading}
          data-testid="auth-login-submit-button"
          className="w-full bg-emerald-500 hover:bg-emerald-600 text-emerald-950 font-semibold h-11 transition-colors duration-150"
        >
          {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : "Entrar"}
        </Button>
      </form>
      {process.env.REACT_APP_SHOW_DEMO_CREDENTIALS === "true" && (
        <div className="mt-6 bg-slate-800/50 border border-slate-700/60 rounded-lg p-3.5 text-xs text-slate-400 space-y-1" data-testid="auth-demo-credentials">
          <p className="font-semibold text-slate-300">Credenciais de demonstração</p>
          <p>Admin: searaagrotransportes@gmail.com / Maturamax@2026</p>
          <p>Cliente: teste@maturamax.com.br / teste123</p>
        </div>
      )}
    </AuthShell>
  );
}
